<template>
    <div>
        <div class="userInfo">
            <div class="left">
                <div class="header">
                    <!--          <div class="user">-->
                    <!--            <img class="avatar"-->
                    <!--                 src=""-->
                    <!--                 alt="头像"/>-->
                    <!--&lt;!&ndash;                                  <img class="avatar"&ndash;&gt;-->
                    <!--&lt;!&ndash;                                       v-if="userInfo.avatar"&ndash;&gt;-->
                    <!--&lt;!&ndash;                                       :src="baseUrl + userInfo.avatar"&ndash;&gt;-->
                    <!--&lt;!&ndash;                                       alt="头像" />&ndash;&gt;-->
                    <!--            &lt;!&ndash;                      <img class="avatar"&ndash;&gt;-->
                    <!--            &lt;!&ndash;                           v-else&ndash;&gt;-->
                    <!--            &lt;!&ndash;                           src="@/assets/default_avatar.png"&ndash;&gt;-->
                    <!--            &lt;!&ndash;                           alt="头像" />&ndash;&gt;-->
                    <!--            <div>-->
                    <!--              <div class="name">缩水王子（缩水师）</div>-->
                    <!--              <div class="content">-->
                    <!--                <div>-->
                    <!--                  <div>双色球：</div>-->
                    <!--                  <div>大乐透：</div>-->
                    <!--                  <div class="lastDiv">缩水列表</div>-->
                    <!--                </div>-->
                    <!--                <div>-->
                    <!--                  <div>福彩3D</div>-->
                    <!--                  <div>体彩排三</div>-->
                    <!--                  <div class="lastDiv">历史成绩</div>-->
                    <!--                </div>-->
                    <!--                <div>-->
                    <!--                  <div>缩币文章</div>-->
                    <!--                  <div>浏览人数</div>-->
                    <!--                  <div class="lastDiv">加入关注</div>-->
                    <!--                </div>-->
                    <!--                <div>-->
                    <!--                  <div>免费预测</div>-->
                    <!--                  <div>粉丝人数</div>-->
                    <!--                  &lt;!&ndash;<div class="lastDiv">放入桌面</div>&ndash;&gt;-->
                    <!--                </div>-->
                    <!--              </div>-->
                    <!--            </div>-->
                    <!--          </div>-->
                    
                    <div class="user">
                        
                        <img class="avatar"
                             v-if="userInfo.avatar"
                             :src="baseUrl + userInfo.avatar"
                             alt="头像"/>
                        <img class="avatar"
                             v-else
                             src="@/assets/default_avatar.png"
                             alt="头像"/>
                        
                        <div>
                            <div class="name">{{ userInfo.nickname }}（缩水师）</div>
                            <div class="content"
                                 style=" margin-top: 12px; line-height: 25px; ">
                                <div>
                                    <div>双色球：{{ userInfo.doubleColorBall || 0 }}</div>
                                    <div>大乐透：{{ userInfo.lottery || 0 }}</div>
                                    <div class="lastDiv">缩水列表</div>
                                </div>
                                <div>
                                    <div>福彩3D：{{ userInfo.fucai3d || 0 }}</div>
                                    <div>体彩排三：{{ userInfo.pailieSan || 0 }}</div>
                                    <div class="lastDiv">历史成绩</div>
                                </div>
                                <div>
                                    <div>缩币文章：{{ userInfo.payCount || 0 }}</div>
                                    <div>浏览人数：{{ userInfo.freeCount || 0 }}</div>
                                    <div class="lastDiv">加入关注</div>
                                </div>
                                <div>
                                    <div>免费预测：{{ userInfo.passCount || 0 }}</div>
                                    <div>粉丝人数：{{ userInfo.freeCount || 0 }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>
            <div class="right">
                <div v-for="(item, index) in right.arr"
                     :key="index"
                     :class="right.active == index ? 'active' : ''"
                     @click="right.active = index">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <!--    <div class="table">-->
        <!--      <div class="tit">-->
        <!--        <div>-->
        <!--          近期成绩-->
        <!--          <span>双色球</span>-->
        <!--          <span>福彩3D</span>-->
        <!--          <span>大乐透</span>-->
        <!--          <span>排列三</span>-->
        <!--        </div>-->
        <!--        <div>-->
        <!--          <span>历史</span>-->
        <!--          <span>近20期</span>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--      <div class="grid">-->
        <!--        <div>-->
        <!--          <span>期号</span>-->
        <!--          <span>80-89.9万</span>-->
        <!--          <span>50-59.9万</span>-->
        <!--          <span>15-21.9万</span>-->
        <!--          <span>4-4.9万</span>-->
        <!--          <span>5005注以下</span>-->
        <!--          <span>杀6蓝</span>-->
        <!--          <span>围4蓝</span>-->
        <!--        </div>-->
        <!--        <div v-for="(item,index) in 10"-->
        <!--             :key="index">-->
        <!--          <span>123123</span>-->
        <!--          <span>√</span>-->
        <!--          <span>√</span>-->
        <!--          <span>√</span>-->
        <!--          <span>√</span>-->
        <!--          <span>√</span>-->
        <!--          <span>√</span>-->
        <!--          <span>√</span>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </div>-->
        <div class="table2">
            <div class="tit">
                <div>
                    <span>近期成绩</span>
                    <span v-for="(item,index) in lotteryArr"
                          :key="index"
                          :class="{active: index == lotteryActive}"
                          @click="lotteryActive = index">
                            {{ item.title }}
                        </span>
                </div>
                <span>更多预测</span>
            </div>
            <div class="grid"
                 v-loading="recent_results_loading">
                <div :style="['pl3','fc3d'].includes(lotteryArr[lotteryActive].type)?'grid-template-columns: 1fr 2fr repeat(6, 1fr);':''">
                    <span>序号</span>
                    <span>期号/开奖号</span>
                    <span v-for="(item,index) in ys[lotteryArr[lotteryActive].type]" :key="index">{{ item.label }}</span>
                </div>
                <div v-for="(item,index) in recent_results_list"
                     :key="index"
                     :style="['pl3','fc3d'].includes(lotteryArr[lotteryActive].type)?'grid-template-columns: 1fr 2fr repeat(6, 1fr);':''">
                    <span>{{ index + 1 }}</span>
                    <span style="flex-direction: column">
                        {{ item.number }}期<br/>
                        <b v-html="handleOpenNumber(item.openNbr)"></b>
                    </span>
                    <span v-for="(ite,idx) in ys[lotteryArr[lotteryActive].type]"
                          :key="idx"
                          class="sheetItem">
							<b v-if="jsAttr(item.preChampionVOList,ite.value) == '--'" style="color:#000">--</b>
							<b v-else-if="jsAttr(item.preChampionVOList,ite.value) == 1" class="hit-ok">
								<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
									<polyline points="4,13 9,18 20,6"></polyline>
								</svg>
							</b>
							<b v-else class="hit-no">
								<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round">
									<line x1="6" y1="6" x2="18" y2="18"></line>
									<line x1="18" y1="6" x2="6" y2="18"></line>
								</svg>
							</b>
          </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getInfo} from "@/api/hangjiaguanli";

export default {
    watch: {
        lotteryActive() {
            this.recent_achievements()
        }
    },
    computed: {
        jsAttr() {
            return (arr, val) => {
                // console.log(arr,val);
                if (arr.length) {
                    let {isWin, isUpdate} = arr.filter(item => item.preIndexType == val)[0]
                    // return is_win == 1 ? '√' : '×'
                    if (isUpdate == '0') {
                        return '--'
                    } else {
                        return isWin
                    }
                }
            }
        }
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_API + '/stage-api',
            userInfo: {},
            
            right: {
                arr: [
                    {name: "缩水单大厅"},
                    {name: "EXCEL专区"},
                    {name: "缩水软件专区"},
                    {name: "实体投注站帮扶中心"},
                ],
                active: 0
            },
            
            lotteryType: {
                arr: [],
                active: 0
            },
            preIdexType: {
                arr: [],
                active: 0
            },
            
            queryParams: {
                preType: '',
                preIndexType: '',
                backNumber: '',
                createUser: '',
            },
            
            lotteryArr: [
                {preType: 0, title: '双色球', type: 'ssq'},
                {preType: 1, title: '大乐透', type: 'dlt'},
                {preType: 2, title: '福彩3D', type: 'fc3d'},
                {preType: 3, title: '排列三', type: 'pl3'},
            ],
            lotteryActive: 0,
            recent_results_list: [],
            recent_results_loading: false,
            
            ys: {
                ssq: [
                    {label: '90-99.9万', value: 7},
                    {label: '80-89.9万', value: 0},
                    {label: '50-59.9万', value: 1},
                    {label: '15-21.9万', value: 2},
                    {label: '4-4.9万', value: 3},
                    {label: '5005注以下', value: 4},
                    {label: '杀6蓝', value: 5},
                    {label: '围4蓝', value: 6},
                ],
                dlt: [
                    {label: '27-29.9万', value: 7},
                    {label: '20-26.9万', value: 0},
                    {label: '15-17.9万', value: 1},
                    {label: '3-5.9万', value: 2},
                    {label: '1-1.9万', value: 3},
                    {label: '4368注以下', value: 4},
                    {label: '杀5后', value: 5},
                    {label: '围3后', value: 6},
                ],
                fc3d: [
                    {label: '800-899注', value: 5},
                    {label: '700-799注', value: 0},
                    {label: '400-599注', value: 1},
                    {label: '200-399注', value: 2},
                    {label: '50-199注', value: 3},
                    {label: '1-49注', value: 4},
                ],
                pl3: [
                    {label: '800-899注', value: 5},
                    {label: '700-799注', value: 0},
                    {label: '400-599注', value: 1},
                    {label: '200-399注', value: 2},
                    {label: '50-199注', value: 3},
                    {label: '1-49注', value: 4},
                ],
            }
            
            
        };
    },
    mounted() {
        this.getLottery()
        this.getList2()
        
    },
    methods: {
        handleOpenNumber(issueNumber) {
            if (issueNumber) {
                const parts = issueNumber.split(" ");
                const lastNumber = parts.pop(); // 移除最后一个数字
                return ` ${parts.join(" ")} + <span style="color:blue">${lastNumber}</span> `
            }
        },
        getLottery() {
            
            const lotteryTypeMap = {
                '双色球': {type: 'ssq', apiUrl: 'pre_double_index_type'},
                '大乐透': {type: 'dlt', apiUrl: 'pre_lottery_index_type'},
                '福彩3D': {type: 'fc3d', apiUrl: 'pre_fucai3d_index_type'},
                '排列三': {type: 'pl3', apiUrl: 'pre_pailiesan_index_type'},
            };
            
            this.$http.get('/stage-api/system/dict/data/type/pre_type').then(res => {
                
                let lotteryArr = res.data.map(item => {
                    return {
                        label: item.dictLabel,
                        value: item.dictValue,
                        type: lotteryTypeMap[item.dictLabel].type,
                        apiUrl: lotteryTypeMap[item.dictLabel].apiUrl,
                    }
                })
                
                this.lotteryType.arr = lotteryArr
                this.queryParams.preType = this.lotteryType.arr[0].value
                
                this.get_pre_index_type()
            })
        },
        get_pre_index_type() {
            let preIndexType = this.lotteryType.arr[this.lotteryType.active].apiUrl
            this.$http.get('/stage-api/pre/dict/type/' + preIndexType).then(res => {
                let preIdexTypeArr = res.data.map(item => {
                    return (!['杀6蓝', '围4蓝'].includes(item.dictLabel)) && {
                        label: item.dictLabel,
                        value: item.dictValue,
                    }
                })
                this.preIdexType.arr = preIdexTypeArr
                this.getList()
            })
        },
        
        getList() {
            this.$http.get('/stage-api/pre/champion/list?' + this.$utils.getParamByJson(this.queryParams)).then(res => {
                console.log('res', res);
            })
        },
        
        getList2() {
            getInfo({
                userId: this.vuex_userInfo.userId,
            }).then(res => {
                this.userInfo = res.data;
                this.recent_achievements()
            })
        },
        // 近期成绩
        recent_achievements() {
            this.recent_results_list = []
            this.recent_results_loading = true
            this.$http.get('/stage-api/pre/detail/achievmentList', {
                params: {
                    preType: this.lotteryArr[this.lotteryActive].preType,
                    createUser: this.vuex_userInfo.userId,
                }
            }).then(res => {
                this.recent_results_loading = false
                let db = res.rows.splice(0, 20)
                this.recent_results_list = db
            }).catch(err => {
                console.log('err', err);
                this.recent_results_loading = false
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.userInfo {
    display: flex;
    
    .left {
        flex: 1;
        
        .header {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            
            .user {
                display: flex;
                
                .avatar {
                    width: 100px;
                    height: 100px;
                    margin-right: 10px;
                    border: 1px solid red;
                }
                
                > div {
                    flex: 1;
                    
                    .name {
                        color: #bd312a;
                        font-weight: bold;
                    }
                    
                    .content {
                        display: flex;
                        justify-content: space-between;
                        
                        .lastDiv {
                            margin-top: 15px;
                            background-color: #93d2f3;
                            padding: 5px 10px;
                        }
                    }
                }
            }
            
            .msg {
                color: #bd312a;
                margin: 10px 0;
                display: flex;
                
                > div {
                    flex: 1;
                    border-bottom: 1px solid #bd312a;
                }
            }
        }
    }
    
    .right {
        text-align: center;
        margin-left: 10px;
        width: 200px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        
        > div {
            font-weight: bold;
            font-size: 13px;
            color: #bd312a;
            padding: 8px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            cursor: pointer;
            
            &.active {
                background-color: #93d2f3;
            }
        }
    }
}

.table {
    .tit {
        background-color: #93d2f3;
        color: #bd312a;
        display: flex;
        justify-content: space-between;
        
        span {
            display: inline-block;
            padding: 10px;
        }
    }
    
    .grid {
        > div {
            display: grid;
            text-align: center;
            grid-template-columns: repeat(8, 1fr);
            
            span {
                border: 1px solid rgba(0, 0, 0, 0.1);
                padding: 10px 0;
            }
        }
    }
}

.table2 {
    .tit {
        display: flex;
        justify-content: space-between;
        background-color: #93d2f3;
        color: #951d1d;
        padding: 5px 10px;
        
        span {
            margin-right: 10px;
            cursor: pointer;
            
            &.active {
                background-color: #951d1d;
                color: #fff;
            }
        }
    }
    
    .grid {
        font-weight: bold;
        font-size: 10px;
        min-height: 300px;
        
        > div {
            display: grid;
            // grid-template-columns: repeat(10, 1fr);
            grid-template-columns: 1fr 2fr repeat(8, 1fr);
            text-align: center;
            
            &:nth-child(even) {
                background-color: #F2F2F2;
            }
            
            span {
                padding: 5px 0;
                border: 1px solid rgba(0, 0, 0, 0.2);
                display: flex;
                align-items: center;
                justify-content: center;
                
                &:first-child {
                    color: blue;
                }
            }
            
            .sheetItem {
                font-size: 26px;
                line-height: 30px;

                /* 命中标记：用内联 SVG 绘制，不依赖字体，任何设备都能正常显示 */
                .hit-ok {
                    color: #2899DF;

                    svg {
                        vertical-align: middle;
                    }
                }

                .hit-no {
                    color: #f00;

                    svg {
                        vertical-align: middle;
                    }
                }
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    /* 顶部：个人资料与右侧标签改为上下排列 */
    .userInfo {
        flex-direction: column;

        .left {
            .header {
                padding: 8px;

                .user {
                    .avatar {
                        width: 56px;
                        height: 56px;
                        margin-right: 8px;
                    }

                    /* 数据统计：四列改两列 */
                    .content {
                        flex-wrap: wrap;

                        >div {
                            width: 50%;
                        }
                    }
                }
            }
        }

        /* 右侧标签：改为横向排列的按钮，可换行 */
        .right {
            width: 100%;
            margin-left: 0;
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            padding: 6px;

            >div {
                padding: 6px 10px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                border-radius: 4px;
                font-size: 12px;
            }
        }
    }

    /* 近期成绩表 */
    .table2 {
        margin-top: 8px;

        .tit {
            flex-wrap: wrap;
            row-gap: 6px;
            padding: 6px 8px;
            align-items: flex-start;

            >div {
                flex: 1;
                min-width: 0;
                display: flex;
                flex-wrap: wrap;
                gap: 6px;

                /* 「近期成绩」标题独占一行，4 个彩种换到第二行 */
                >span:first-child {
                    width: 100%;
                }
            }

            span {
                margin-right: 0;
                padding: 3px 8px;
                font-size: 12px;
            }
        }

        /* 表格保持可读宽度，容器内左右滑动 */
        .grid {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;

            >div {
                min-width: 780px;
            }
        }
    }
}
</style>
